$(document).ready(function () {
  function isDesktop() {
    return window.matchMedia("(min-width: 1024px)").matches;
  }

  // Function to calculate and set submenu height
  function setSubmenuHeight() {
    if (isDesktop()) {
      // Get the height of the active menu or the first menu
      const $activeMenu = $(".three_menus.active");
      const menuHeight = $activeMenu.length
        ? $activeMenu.outerHeight() + 20 // Add padding
        : $(".three_menus.first_menu").outerHeight() + 20; // Fallback to first menu
      $(".submenu").css("height", `${menuHeight}px`);
      console.log("Submenu height set to:", menuHeight);
    }
  }

  // Set initial height on page load
  setSubmenuHeight();

  // Update height on hover for menu items
  $(".menu_item-link").hover(function () {
    if (isDesktop()) {
      $(".three_menus").removeClass("active");
      $(this).next(".three_menus").addClass("active");
      setSubmenuHeight(); // Recalculate height on hover
    }
  });

  // Update height and margin for cus_side_links
  $(".cus_side_links").hover(function () {
    if (isDesktop()) {
      const $activeMenu = $(".three_menus.active");
      const menuHeight = $activeMenu.length ? $activeMenu.outerHeight() + 80 : 250;
      $(".submenu").css("height", `${menuHeight}px`);
      console.log("Menu height:", menuHeight);

      const liHeight = $(this).outerHeight();
      const previousLiHeights = $(this)
        .parents()
        .prevAll("li.menu-link.level-1")
        .toArray()
        .reduce((acc, li) => acc + $(li).outerHeight(), 0);
      const marginTop = window.innerWidth > 1400 ? -(previousLiHeights + liHeight - 35) : -(previousLiHeights + liHeight - 45);
      console.log("Previous li cumulative height:", previousLiHeights);
      console.log("Current li height:", liHeight);
      console.log("New margin-top:", marginTop);
      $activeMenu.css("margin-top", `${marginTop}px`);
    }
  });

  // Handle hover for menu-parent dropdown
  $("li.menu-parent.dropdown-menu").hover(
    function () {
      if (isDesktop()) {
        $(".three_menus").removeClass("active");
        $(this).find(".three_menus:first").addClass("active");
        setSubmenuHeight(); // Recalculate height on hover
        console.log("Hovered over li - first element activated");
      }
    },
    function () {
      if (isDesktop()) {
        $(this).find(".three_menus:first").removeClass("active");
        console.log("Hover removed from li - first element deactivated");
      }
    }
  );

  // Update height on window resize to handle responsive changes
  $(window).resize(setSubmenuHeight);
});